// extracted by mini-css-extract-plugin
module.exports = {"component":"State_component__1-4-a","icon":"State_icon__3Lf45","content":"State_content__1y8dr"};